import React, { Component } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import SideNav, { NavItem, NavIcon } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import Home from './home';
import Universities from "./universities";
import Users from "./users";

class Dashboard extends Component {
    state = {
        icons: {
            dashboard: "./icons/dashboard.png"
        }
    }

    render() {
        return (
            <div className="d-flex">
                <Router>
                    <Route render={({ location, history }) => (
                        <React.Fragment>
                            <SideNav
                                onSelect={(selected) => {
                                    const to = '/' + selected;
                                    if (location.pathname !== to) {
                                        history.push(to);
                                    }
                                }}
                                className="dashboard-nav"
                            >
                                <div className="text-center py-3">
                                    <img src="/images/logo-white.png" alt="logo" width="35" height="35" />
                                </div>
                                <SideNav.Nav>
                                    <NavItem eventKey="dashboard/home" className="nav-item" active={location.pathname.includes("/dashboard/home")}>
                                        <NavIcon>
                                            <img src={location.pathname.includes("/dashboard/home") ? "/icons/dashboard-blue.png" : "/icons/dashboard-white.png"} alt="control" width="20" height="20" />
                                            <h6 className="mt-n3">التحكم</h6>
                                        </NavIcon>
                                    </NavItem>
                                    <NavItem eventKey="dashboard/universities" className="nav-item" active={location.pathname.includes("/dashboard/universities")} disabled={location.pathname==="/buses"}>
                                        <NavIcon>
                                            <img src={location.pathname.includes("/dashboard/universities") ? "/icons/university-blue.png" : "/icons/university-white.png"} alt="universities" width="20" height="20" />
                                            <h6 className="mt-n3">الجامعات</h6>
                                        </NavIcon>
                                    </NavItem>
                                    <NavItem eventKey="dashboard/users" className="nav-item" active={location.pathname.includes("/dashboard/users")}>
                                        <NavIcon>
                                            <img src={location.pathname.includes("/dashboard/users") ? "/icons/user-blue.png" : "/icons/user-white.png"} alt="users" width="20" height="20" />
                                            <h6 className="mt-n3">المستخدمون</h6>
                                        </NavIcon>
                                    </NavItem>
                                </SideNav.Nav>
                            </SideNav>
                            <main className="dashboard w-100">
                                <Route path="/dashboard/home" component={props => <Home />} />
                                <Route path="/dashboard/universities" component={props => <Universities />} />
                                <Route path="/dashboard/users" component={props => <Users />} />
                                <Route exact path="/dashboard" render={() => <Redirect to="/dashboard/home" />} />
                            </main>
                        </React.Fragment>
                    )}
                    />
                </Router>
            </div>
        )
    }
}

export default Dashboard;